export default __webpack_public_path__ + "media/components/Pages/Index/Images/Play-e9157afeb7af1426d7b57fda3a7eb175.svg";